import { useState, type CSSProperties } from 'react';

const RESUME_URL = 'https://koruke.com/resume';
const LINKEDIN_URL = 'https://www.linkedin.com/in/bvlqz/';

export function SignatureCard() {
  return (
    <div className="signature-card" style={panel}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 7, marginBottom: 3 }}>
        <span style={dot} />
        <span style={{ fontWeight: 600 }}>Submission from Jorge Becerra</span>
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
        <LinkButton href={RESUME_URL} label="Résumé" />
        <LinkButton href={LINKEDIN_URL} label="LinkedIn" />
      </div>
    </div>
  );
}

function LinkButton({ href, label }: { href: string; label: string }) {
  const [hover, setHover] = useState(false);
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        ...link,
        borderColor: hover ? '#4f9cff' : 'rgba(255,255,255,0.15)',
        color: hover ? '#ffffff' : '#e6edf3',
      }}
    >
      {label} <span style={{ opacity: 0.7 }}>↗</span>
    </a>
  );
}

const panel: CSSProperties = {
  position: 'fixed',
  right: 16,
  bottom: 20,
  padding: '10px 12px',
  borderRadius: 8,
  background: 'rgba(12,16,22,0.72)',
  color: '#e6edf3',
  font: '12px/1.45 system-ui, sans-serif',
  backdropFilter: 'blur(6px)',
  border: '1px solid rgba(255,255,255,0.08)',
  userSelect: 'none',
  zIndex: 5,
};

const dot: CSSProperties = {
  width: 7,
  height: 7,
  borderRadius: '50%',
  background: '#4f9cff',
  boxShadow: '0 0 6px #4f9cff',
};

const link: CSSProperties = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  padding: '4px 10px',
  borderRadius: 6,
  border: '1px solid rgba(255,255,255,0.15)',
  textDecoration: 'none',
  fontWeight: 500,
  transition: 'color 150ms ease, border-color 150ms ease',
};
